import { combineReducers } from 'redux'

import { reducer as resetPasswordModal } from './State/resetPasswordModal'

export default combineReducers({
  resetPasswordModal,
})
